/* oxlint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as DesignStudioEmbedRouteImport } from './routes/design-studio-embed';
import { Route as CliRouteImport } from './routes/cli';
import { Route as CheckoutRouteImport } from './routes/checkout';
import { Route as AcademyLoginRouteImport } from './routes/academy-login';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as CliIndexRouteImport } from './routes/cli.index';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index';
import { Route as VwbDemoSplatRouteImport } from './routes/vwb-demo.$';
import { Route as UsersSplatRouteImport } from './routes/users.$';
import { Route as SignupSplatRouteImport } from './routes/signup.$';
import { Route as Reset_passwordSplatRouteImport } from './routes/reset_password.$';
import { Route as Post_registrationSplatRouteImport } from './routes/post_registration.$';
import { Route as Post_cancelSplatRouteImport } from './routes/post_cancel.$';
import { Route as Oauth2SplatRouteImport } from './routes/oauth2.$';
import { Route as OauthSplatRouteImport } from './routes/oauth.$';
import { Route as No_accessible_workspacesSplatRouteImport } from './routes/no_accessible_workspaces.$';
import { Route as LogoutSplatRouteImport } from './routes/logout.$';
import { Route as LoginSplatRouteImport } from './routes/login.$';
import { Route as JourneysSplatRouteImport } from './routes/journeys.$';
import { Route as IntegrationsSplatRouteImport } from './routes/integrations.$';
import { Route as HarSanitizerSplatRouteImport } from './routes/har-sanitizer.$';
import { Route as EnvSplatRouteImport } from './routes/env.$';
import { Route as Confirm_account_noticeSplatRouteImport } from './routes/confirm_account_notice.$';
import { Route as Confirm_accountSplatRouteImport } from './routes/confirm_account.$';
import { Route as CliDnsSetupRouteImport } from './routes/cli.dns-setup';
import { Route as Account_cancelledSplatRouteImport } from './routes/account_cancelled.$';
import { Route as Account_canceledSplatRouteImport } from './routes/account_canceled.$';
import { Route as AccountSplatRouteImport } from './routes/account.$';
import { Route as AuthenticatedWorkspacesRouteImport } from './routes/_authenticated.workspaces';
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated.$';
import { Route as R2fa_setupSplatRouteImport } from './routes/2fa_setup.$';
import { Route as DesignStudioEmbedCioIndexRouteImport } from './routes/design-studio-embed.cio.index';
import { Route as AuthenticatedWorkspacesIndexRouteImport } from './routes/_authenticated.workspaces.index';
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated.settings.index';
import { Route as AuthenticatedSampleWorkspaceIndexRouteImport } from './routes/_authenticated.sample-workspace.index';
import { Route as AuthenticatedInternalToolsIndexRouteImport } from './routes/_authenticated.internal-tools.index';
import { Route as DesignStudioEmbedCioSplatRouteImport } from './routes/design-studio-embed.cio.$';
import { Route as AccountCancelledSplatRouteImport } from './routes/account.cancelled.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId';
import { Route as AuthenticatedTrialExpiredJourneysRouteImport } from './routes/_authenticated.trial-expired.journeys';
import { Route as AuthenticatedSettingsPrivacyRouteImport } from './routes/_authenticated.settings.privacy';
import { Route as AuthenticatedSettingsExperimentalFeaturesRouteImport } from './routes/_authenticated.settings.experimental-features';
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated.settings.audit-logs';
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated.settings.api-keys';
import { Route as AuthenticatedSettingsAiRouteImport } from './routes/_authenticated.settings.ai';
import { Route as AuthenticatedSettingsSplatRouteImport } from './routes/_authenticated.settings.$';
import { Route as AuthenticatedSampleWorkspaceSplatRouteImport } from './routes/_authenticated.sample-workspace.$';
import { Route as AuthenticatedInternalToolsSplatRouteImport } from './routes/_authenticated.internal-tools.$';
import { Route as PipelinesWorkspacesWorkspaceIdIndexRouteImport } from './routes/pipelines.workspaces.$workspaceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.index';
import { Route as AuthenticatedSettingsRolesIndexRouteImport } from './routes/_authenticated.settings.roles.index';
import { Route as AuthenticatedSettingsAccountIndexRouteImport } from './routes/_authenticated.settings.account.index';
import { Route as PipelinesWorkspacesWorkspaceIdSplatRouteImport } from './routes/pipelines.workspaces.$workspaceId.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys_';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home';
import { Route as AuthenticatedWorkspacesWorkspaceIdHealthRouteImport } from './routes/_authenticated.workspaces.$workspaceId.health';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio';
import { Route as AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent';
import { Route as AuthenticatedWorkspacesWorkspaceIdSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.$';
import { Route as AuthenticatedSettingsRolesNewRouteImport } from './routes/_authenticated.settings.roles.new';
import { Route as AuthenticatedSettingsRolesRoleIdRouteImport } from './routes/_authenticated.settings.roles.$roleId';
import { Route as AuthenticatedSettingsAccountEditRouteImport } from './routes/_authenticated.settings.account.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.suppressions';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.merge_options';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.auto_archive';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.audit-logs';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api-keys';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.anonymous_events';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.ai-business-profile';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.condition-viewer';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.routines';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sinch';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.$skillPath';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add_.$sourceOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.syncs';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.imports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.databases';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.data-in';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add_.$destinationOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.tester';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.data-out';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.$syncId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.$subscriptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.actions.$actionId';

const DesignStudioEmbedRoute = DesignStudioEmbedRouteImport.update({
  id: '/design-studio-embed',
  path: '/design-studio-embed',
  getParentRoute: () => rootRouteImport,
} as any);
const CliRoute = CliRouteImport.update({
  id: '/cli',
  path: '/cli',
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any);
const AcademyLoginRoute = AcademyLoginRouteImport.update({
  id: '/academy-login',
  path: '/academy-login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const CliIndexRoute = CliIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CliRoute,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const VwbDemoSplatRoute = VwbDemoSplatRouteImport.update({
  id: '/vwb-demo/$',
  path: '/vwb-demo/$',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersSplatRoute = UsersSplatRouteImport.update({
  id: '/users/$',
  path: '/users/$',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupSplatRoute = SignupSplatRouteImport.update({
  id: '/signup/$',
  path: '/signup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Reset_passwordSplatRoute = Reset_passwordSplatRouteImport.update({
  id: '/reset_password/$',
  path: '/reset_password/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Post_registrationSplatRoute = Post_registrationSplatRouteImport.update({
  id: '/post_registration/$',
  path: '/post_registration/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Post_cancelSplatRoute = Post_cancelSplatRouteImport.update({
  id: '/post_cancel/$',
  path: '/post_cancel/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Oauth2SplatRoute = Oauth2SplatRouteImport.update({
  id: '/oauth2/$',
  path: '/oauth2/$',
  getParentRoute: () => rootRouteImport,
} as any);
const OauthSplatRoute = OauthSplatRouteImport.update({
  id: '/oauth/$',
  path: '/oauth/$',
  getParentRoute: () => rootRouteImport,
} as any);
const No_accessible_workspacesSplatRoute =
  No_accessible_workspacesSplatRouteImport.update({
    id: '/no_accessible_workspaces/$',
    path: '/no_accessible_workspaces/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const LogoutSplatRoute = LogoutSplatRouteImport.update({
  id: '/logout/$',
  path: '/logout/$',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginSplatRoute = LoginSplatRouteImport.update({
  id: '/login/$',
  path: '/login/$',
  getParentRoute: () => rootRouteImport,
} as any);
const JourneysSplatRoute = JourneysSplatRouteImport.update({
  id: '/journeys/$',
  path: '/journeys/$',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsSplatRoute = IntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => rootRouteImport,
} as any);
const HarSanitizerSplatRoute = HarSanitizerSplatRouteImport.update({
  id: '/har-sanitizer/$',
  path: '/har-sanitizer/$',
  getParentRoute: () => rootRouteImport,
} as any);
const EnvSplatRoute = EnvSplatRouteImport.update({
  id: '/env/$',
  path: '/env/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Confirm_account_noticeSplatRoute =
  Confirm_account_noticeSplatRouteImport.update({
    id: '/confirm_account_notice/$',
    path: '/confirm_account_notice/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const Confirm_accountSplatRoute = Confirm_accountSplatRouteImport.update({
  id: '/confirm_account/$',
  path: '/confirm_account/$',
  getParentRoute: () => rootRouteImport,
} as any);
const CliDnsSetupRoute = CliDnsSetupRouteImport.update({
  id: '/dns-setup',
  path: '/dns-setup',
  getParentRoute: () => CliRoute,
} as any);
const Account_cancelledSplatRoute = Account_cancelledSplatRouteImport.update({
  id: '/account_cancelled/$',
  path: '/account_cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Account_canceledSplatRoute = Account_canceledSplatRouteImport.update({
  id: '/account_canceled/$',
  path: '/account_canceled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSplatRoute = AccountSplatRouteImport.update({
  id: '/account/$',
  path: '/account/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const R2fa_setupSplatRoute = R2fa_setupSplatRouteImport.update({
  id: '/2fa_setup/$',
  path: '/2fa_setup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignStudioEmbedCioIndexRoute =
  DesignStudioEmbedCioIndexRouteImport.update({
    id: '/cio/',
    path: '/cio/',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const AuthenticatedWorkspacesIndexRoute =
  AuthenticatedWorkspacesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceIndexRoute =
  AuthenticatedSampleWorkspaceIndexRouteImport.update({
    id: '/sample-workspace/',
    path: '/sample-workspace/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsIndexRoute =
  AuthenticatedInternalToolsIndexRouteImport.update({
    id: '/internal-tools/',
    path: '/internal-tools/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const DesignStudioEmbedCioSplatRoute =
  DesignStudioEmbedCioSplatRouteImport.update({
    id: '/cio/$',
    path: '/cio/$',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const AccountCancelledSplatRoute = AccountCancelledSplatRouteImport.update({
  id: '/account/cancelled/$',
  path: '/account/cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspacesWorkspaceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedTrialExpiredJourneysRoute =
  AuthenticatedTrialExpiredJourneysRouteImport.update({
    id: '/trial-expired/journeys',
    path: '/trial-expired/journeys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPrivacyRoute =
  AuthenticatedSettingsPrivacyRouteImport.update({
    id: '/settings/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsExperimentalFeaturesRoute =
  AuthenticatedSettingsExperimentalFeaturesRouteImport.update({
    id: '/settings/experimental-features',
    path: '/settings/experimental-features',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAiRoute = AuthenticatedSettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSettingsSplatRoute =
  AuthenticatedSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceSplatRoute =
  AuthenticatedSampleWorkspaceSplatRouteImport.update({
    id: '/sample-workspace/$',
    path: '/sample-workspace/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsSplatRoute =
  AuthenticatedInternalToolsSplatRouteImport.update({
    id: '/internal-tools/$',
    path: '/internal-tools/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const PipelinesWorkspacesWorkspaceIdIndexRoute =
  PipelinesWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/',
    path: '/pipelines/workspaces/$workspaceId/',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedSettingsRolesIndexRoute =
  AuthenticatedSettingsRolesIndexRouteImport.update({
    id: '/settings/roles/',
    path: '/settings/roles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountIndexRoute =
  AuthenticatedSettingsAccountIndexRouteImport.update({
    id: '/settings/account/',
    path: '/settings/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const PipelinesWorkspacesWorkspaceIdSplatRoute =
  PipelinesWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/$',
    path: '/pipelines/workspaces/$workspaceId/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport.update({
    id: '/snippets',
    path: '/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport.update({
    id: '/journeys_',
    path: '/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHealthRoute =
  AuthenticatedWorkspacesWorkspaceIdHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdGeofencesRouteImport.update({
    id: '/geofences',
    path: '/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport.update({
    id: '/design-studio',
    path: '/design-studio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedSettingsRolesNewRoute =
  AuthenticatedSettingsRolesNewRouteImport.update({
    id: '/settings/roles/new',
    path: '/settings/roles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesRoleIdRoute =
  AuthenticatedSettingsRolesRoleIdRouteImport.update({
    id: '/settings/roles/$roleId',
    path: '/settings/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountEditRoute =
  AuthenticatedSettingsAccountEditRouteImport.update({
    id: '/settings/account/edit',
    path: '/settings/account/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport.update({
    id: '/parcel/',
    path: '/parcel/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport.update({
    id: '/$snippetId',
    path: '/$snippetId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport.update({
    id: '/settings/suppressions',
    path: '/settings/suppressions',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport.update({
    id: '/settings/merge_options',
    path: '/settings/merge_options',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport.update({
    id: '/settings/auto_archive',
    path: '/settings/auto_archive',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport.update({
    id: '/settings/anonymous_events',
    path: '/settings/anonymous_events',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport.update(
    {
      id: '/settings/ai-business-profile',
      path: '/settings/ai-business-profile',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport.update({
    id: '/parcel/$',
    path: '/parcel/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport.update({
    id: '/journeys/tasks',
    path: '/journeys/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport.update({
    id: '/journeys/snippets',
    path: '/journeys/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport.update({
    id: '/journeys/settings',
    path: '/journeys/settings',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport.update({
    id: '/journeys/geofences',
    path: '/journeys/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport.update({
    id: '/journeys/exports',
    path: '/journeys/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport.update({
    id: '/journeys/assets',
    path: '/journeys/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport.update({
    id: '/journeys/$',
    path: '/journeys/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport.update({
    id: '/workspace-setup',
    path: '/workspace-setup',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport.update({
    id: '/add-people',
    path: '/add-people',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGeofencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRouteImport.update({
    id: '/$geofenceId',
    path: '/$geofenceId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute =
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport.update({
    id: '/dev/condition-viewer',
    path: '/dev/condition-viewer',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport.update({
    id: '/analysis/deliverability',
    path: '/analysis/deliverability',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport.update({
    id: '/routines',
    path: '/routines',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport.update({
    id: '/pipelines/sources/',
    path: '/pipelines/sources/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport.update(
    {
      id: '/pipelines/destinations/',
      path: '/pipelines/destinations/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRouteImport.update({
    id: '/settings/actions/sinch',
    path: '/settings/actions/sinch',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport.update({
    id: '/pipelines/sources/journeys',
    path: '/pipelines/sources/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport.update({
    id: '/pipelines/sources/add',
    path: '/pipelines/sources/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport.update({
    id: '/pipelines/sources/$sourceId',
    path: '/pipelines/sources/$sourceId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport.update(
    {
      id: '/pipelines/destinations/journeys',
      path: '/pipelines/destinations/journeys',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport.update({
    id: '/pipelines/destinations/add',
    path: '/pipelines/destinations/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport.update(
    {
      id: '/pipelines/destinations/$destinationId',
      path: '/pipelines/destinations/$destinationId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport.update(
    {
      id: '/$snippetId',
      path: '/$snippetId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport.update(
    {
      id: '/$geofenceId',
      path: '/$geofenceId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport.update(
    {
      id: '/journeys/analysis/deliverability',
      path: '/journeys/analysis/deliverability',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport.update(
    {
      id: '/add-people',
      path: '/add-people',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport.update({
    id: '/dev/db/campaigns',
    path: '/dev/db/campaigns',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport.update({
    id: '/$skillPath',
    path: '/$skillPath',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport.update(
    {
      id: '/pipelines/sources/add_/$sourceOptionId',
      path: '/pipelines/sources/add/$sourceOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport.update(
    {
      id: '/syncs',
      path: '/syncs',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport.update(
    {
      id: '/imports',
      path: '/imports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport.update(
    {
      id: '/databases',
      path: '/databases',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport.update(
    {
      id: '/data-in',
      path: '/data-in',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport.update(
    {
      id: '/pipelines/destinations/add_/$destinationOptionId',
      path: '/pipelines/destinations/add/$destinationOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport.update(
    {
      id: '/tester',
      path: '/tester',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport.update(
    {
      id: '/subscriptions',
      path: '/subscriptions',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport.update(
    {
      id: '/exports',
      path: '/exports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport.update(
    {
      id: '/data-out',
      path: '/data-out',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport.update(
    {
      id: '/pipelines/sources/$sourceId_/syncs/add',
      path: '/pipelines/sources/$sourceId/syncs/add',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport.update(
    {
      id: '/pipelines/sources/$sourceId_/syncs/$syncId',
      path: '/pipelines/sources/$sourceId/syncs/$syncId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport.update(
    {
      id: '/$subscriptionId',
      path: '/$subscriptionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport.update(
    {
      id: '/actions/$actionId',
      path: '/actions/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/academy-login': typeof AcademyLoginRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/cli/': typeof CliIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/settings/actions/sinch': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute;
  '/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}
export interface FileRoutesByTo {
  '/academy-login': typeof AcademyLoginRoute;
  '/checkout': typeof CheckoutRoute;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/cli': typeof CliIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/internal-tools': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/roles': typeof AuthenticatedSettingsRolesIndexRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/parcel': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/pipelines': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/settings/actions/sinch': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/academy-login': typeof AcademyLoginRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/_authenticated/$': typeof AuthenticatedSplatRoute;
  '/_authenticated/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/cli/': typeof CliIndexRoute;
  '/_authenticated/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/_authenticated/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/_authenticated/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/_authenticated/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/_authenticated/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/_authenticated/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/_authenticated/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/_authenticated/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/_authenticated/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/_authenticated/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/_authenticated/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/_authenticated/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/_authenticated/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/_authenticated/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/_authenticated/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/_authenticated/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys_': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/_authenticated/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/_authenticated/workspaces/$workspaceId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/_authenticated/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/_authenticated/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/_authenticated/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sinch': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/academy-login'
    | '/checkout'
    | '/cli'
    | '/design-studio-embed'
    | '/2fa_setup/$'
    | '/$'
    | '/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/cli/'
    | '/internal-tools/$'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/experimental-features'
    | '/settings/privacy'
    | '/trial-expired/journeys'
    | '/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/internal-tools/'
    | '/sample-workspace/'
    | '/settings/'
    | '/workspaces/'
    | '/design-studio-embed/cio/'
    | '/settings/account/edit'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/geofences'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account/'
    | '/settings/roles/'
    | '/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geofences/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/agent/'
    | '/workspaces/$workspaceId/design-studio/'
    | '/workspaces/$workspaceId/geofences/'
    | '/workspaces/$workspaceId/home/'
    | '/workspaces/$workspaceId/parcel/'
    | '/workspaces/$workspaceId/pipelines/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/snippets/'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/settings/actions/sinch'
    | '/workspaces/$workspaceId/agent/skills/'
    | '/workspaces/$workspaceId/home/workspace-setup/'
    | '/workspaces/$workspaceId/journeys/geofences/'
    | '/workspaces/$workspaceId/journeys/snippets/'
    | '/workspaces/$workspaceId/pipelines/destinations/'
    | '/workspaces/$workspaceId/pipelines/sources/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/dev/db/campaigns/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/academy-login'
    | '/checkout'
    | '/design-studio-embed'
    | '/2fa_setup/$'
    | '/$'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/'
    | '/cli'
    | '/internal-tools/$'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/experimental-features'
    | '/settings/privacy'
    | '/trial-expired/journeys'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/internal-tools'
    | '/sample-workspace'
    | '/settings'
    | '/workspaces'
    | '/design-studio-embed/cio'
    | '/settings/account/edit'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account'
    | '/settings/roles'
    | '/workspaces/$workspaceId'
    | '/pipelines/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geofences/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/geofences'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/parcel'
    | '/workspaces/$workspaceId/pipelines'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/settings/actions/sinch'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/pipelines/destinations'
    | '/workspaces/$workspaceId/pipelines/sources'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
  id:
    | '__root__'
    | '/_authenticated'
    | '/academy-login'
    | '/checkout'
    | '/cli'
    | '/design-studio-embed'
    | '/2fa_setup/$'
    | '/_authenticated/$'
    | '/_authenticated/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/_authenticated/'
    | '/cli/'
    | '/_authenticated/internal-tools/$'
    | '/_authenticated/sample-workspace/$'
    | '/_authenticated/settings/$'
    | '/_authenticated/settings/ai'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/experimental-features'
    | '/_authenticated/settings/privacy'
    | '/_authenticated/trial-expired/journeys'
    | '/_authenticated/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/_authenticated/internal-tools/'
    | '/_authenticated/sample-workspace/'
    | '/_authenticated/settings/'
    | '/_authenticated/workspaces/'
    | '/design-studio-embed/cio/'
    | '/_authenticated/settings/account/edit'
    | '/_authenticated/settings/roles/$roleId'
    | '/_authenticated/settings/roles/new'
    | '/_authenticated/workspaces/$workspaceId/$'
    | '/_authenticated/workspaces/$workspaceId/agent'
    | '/_authenticated/workspaces/$workspaceId/assets'
    | '/_authenticated/workspaces/$workspaceId/design-studio'
    | '/_authenticated/workspaces/$workspaceId/exports'
    | '/_authenticated/workspaces/$workspaceId/geofences'
    | '/_authenticated/workspaces/$workspaceId/health'
    | '/_authenticated/workspaces/$workspaceId/home'
    | '/_authenticated/workspaces/$workspaceId/journeys_'
    | '/_authenticated/workspaces/$workspaceId/snippets'
    | '/_authenticated/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/_authenticated/settings/account/'
    | '/_authenticated/settings/roles/'
    | '/_authenticated/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/_authenticated/workspaces/$workspaceId/agent/routines'
    | '/_authenticated/workspaces/$workspaceId/agent/skills'
    | '/_authenticated/workspaces/$workspaceId/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/design-studio/$'
    | '/_authenticated/workspaces/$workspaceId/dev/condition-viewer'
    | '/_authenticated/workspaces/$workspaceId/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/home/add-people'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup'
    | '/_authenticated/workspaces/$workspaceId/journeys/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/assets'
    | '/_authenticated/workspaces/$workspaceId/journeys/exports'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets'
    | '/_authenticated/workspaces/$workspaceId/journeys/tasks'
    | '/_authenticated/workspaces/$workspaceId/parcel/$'
    | '/_authenticated/workspaces/$workspaceId/settings/$'
    | '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile'
    | '/_authenticated/workspaces/$workspaceId/settings/anonymous_events'
    | '/_authenticated/workspaces/$workspaceId/settings/api-keys'
    | '/_authenticated/workspaces/$workspaceId/settings/audit-logs'
    | '/_authenticated/workspaces/$workspaceId/settings/auto_archive'
    | '/_authenticated/workspaces/$workspaceId/settings/merge_options'
    | '/_authenticated/workspaces/$workspaceId/settings/suppressions'
    | '/_authenticated/workspaces/$workspaceId/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/agent/'
    | '/_authenticated/workspaces/$workspaceId/design-studio/'
    | '/_authenticated/workspaces/$workspaceId/geofences/'
    | '/_authenticated/workspaces/$workspaceId/home/'
    | '/_authenticated/workspaces/$workspaceId/parcel/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/'
    | '/_authenticated/workspaces/$workspaceId/settings/'
    | '/_authenticated/workspaces/$workspaceId/snippets/'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/new'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sinch'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AcademyLoginRoute: typeof AcademyLoginRoute;
  CheckoutRoute: typeof CheckoutRoute;
  CliRoute: typeof CliRouteWithChildren;
  DesignStudioEmbedRoute: typeof DesignStudioEmbedRouteWithChildren;
  R2fa_setupSplatRoute: typeof R2fa_setupSplatRoute;
  AccountSplatRoute: typeof AccountSplatRoute;
  Account_canceledSplatRoute: typeof Account_canceledSplatRoute;
  Account_cancelledSplatRoute: typeof Account_cancelledSplatRoute;
  Confirm_accountSplatRoute: typeof Confirm_accountSplatRoute;
  Confirm_account_noticeSplatRoute: typeof Confirm_account_noticeSplatRoute;
  EnvSplatRoute: typeof EnvSplatRoute;
  HarSanitizerSplatRoute: typeof HarSanitizerSplatRoute;
  IntegrationsSplatRoute: typeof IntegrationsSplatRoute;
  JourneysSplatRoute: typeof JourneysSplatRoute;
  LoginSplatRoute: typeof LoginSplatRoute;
  LogoutSplatRoute: typeof LogoutSplatRoute;
  No_accessible_workspacesSplatRoute: typeof No_accessible_workspacesSplatRoute;
  OauthSplatRoute: typeof OauthSplatRoute;
  Oauth2SplatRoute: typeof Oauth2SplatRoute;
  Post_cancelSplatRoute: typeof Post_cancelSplatRoute;
  Post_registrationSplatRoute: typeof Post_registrationSplatRoute;
  Reset_passwordSplatRoute: typeof Reset_passwordSplatRoute;
  SignupSplatRoute: typeof SignupSplatRoute;
  UsersSplatRoute: typeof UsersSplatRoute;
  VwbDemoSplatRoute: typeof VwbDemoSplatRoute;
  AccountCancelledSplatRoute: typeof AccountCancelledSplatRoute;
  PipelinesWorkspacesWorkspaceIdSplatRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  PipelinesWorkspacesWorkspaceIdIndexRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/design-studio-embed': {
      id: '/design-studio-embed';
      path: '/design-studio-embed';
      fullPath: '/design-studio-embed';
      preLoaderRoute: typeof DesignStudioEmbedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli': {
      id: '/cli';
      path: '/cli';
      fullPath: '/cli';
      preLoaderRoute: typeof CliRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/checkout': {
      id: '/checkout';
      path: '/checkout';
      fullPath: '/checkout';
      preLoaderRoute: typeof CheckoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/academy-login': {
      id: '/academy-login';
      path: '/academy-login';
      fullPath: '/academy-login';
      preLoaderRoute: typeof AcademyLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli/': {
      id: '/cli/';
      path: '/';
      fullPath: '/cli/';
      preLoaderRoute: typeof CliIndexRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/vwb-demo/$': {
      id: '/vwb-demo/$';
      path: '/vwb-demo/$';
      fullPath: '/vwb-demo/$';
      preLoaderRoute: typeof VwbDemoSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users/$': {
      id: '/users/$';
      path: '/users/$';
      fullPath: '/users/$';
      preLoaderRoute: typeof UsersSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup/$': {
      id: '/signup/$';
      path: '/signup/$';
      fullPath: '/signup/$';
      preLoaderRoute: typeof SignupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset_password/$': {
      id: '/reset_password/$';
      path: '/reset_password/$';
      fullPath: '/reset_password/$';
      preLoaderRoute: typeof Reset_passwordSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/post_registration/$': {
      id: '/post_registration/$';
      path: '/post_registration/$';
      fullPath: '/post_registration/$';
      preLoaderRoute: typeof Post_registrationSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/post_cancel/$': {
      id: '/post_cancel/$';
      path: '/post_cancel/$';
      fullPath: '/post_cancel/$';
      preLoaderRoute: typeof Post_cancelSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth2/$': {
      id: '/oauth2/$';
      path: '/oauth2/$';
      fullPath: '/oauth2/$';
      preLoaderRoute: typeof Oauth2SplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth/$': {
      id: '/oauth/$';
      path: '/oauth/$';
      fullPath: '/oauth/$';
      preLoaderRoute: typeof OauthSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/no_accessible_workspaces/$': {
      id: '/no_accessible_workspaces/$';
      path: '/no_accessible_workspaces/$';
      fullPath: '/no_accessible_workspaces/$';
      preLoaderRoute: typeof No_accessible_workspacesSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logout/$': {
      id: '/logout/$';
      path: '/logout/$';
      fullPath: '/logout/$';
      preLoaderRoute: typeof LogoutSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login/$': {
      id: '/login/$';
      path: '/login/$';
      fullPath: '/login/$';
      preLoaderRoute: typeof LoginSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/journeys/$': {
      id: '/journeys/$';
      path: '/journeys/$';
      fullPath: '/journeys/$';
      preLoaderRoute: typeof JourneysSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/$': {
      id: '/integrations/$';
      path: '/integrations/$';
      fullPath: '/integrations/$';
      preLoaderRoute: typeof IntegrationsSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/har-sanitizer/$': {
      id: '/har-sanitizer/$';
      path: '/har-sanitizer/$';
      fullPath: '/har-sanitizer/$';
      preLoaderRoute: typeof HarSanitizerSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/env/$': {
      id: '/env/$';
      path: '/env/$';
      fullPath: '/env/$';
      preLoaderRoute: typeof EnvSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/confirm_account_notice/$': {
      id: '/confirm_account_notice/$';
      path: '/confirm_account_notice/$';
      fullPath: '/confirm_account_notice/$';
      preLoaderRoute: typeof Confirm_account_noticeSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/confirm_account/$': {
      id: '/confirm_account/$';
      path: '/confirm_account/$';
      fullPath: '/confirm_account/$';
      preLoaderRoute: typeof Confirm_accountSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli/dns-setup': {
      id: '/cli/dns-setup';
      path: '/dns-setup';
      fullPath: '/cli/dns-setup';
      preLoaderRoute: typeof CliDnsSetupRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/account_cancelled/$': {
      id: '/account_cancelled/$';
      path: '/account_cancelled/$';
      fullPath: '/account_cancelled/$';
      preLoaderRoute: typeof Account_cancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account_canceled/$': {
      id: '/account_canceled/$';
      path: '/account_canceled/$';
      fullPath: '/account_canceled/$';
      preLoaderRoute: typeof Account_canceledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/$': {
      id: '/account/$';
      path: '/account/$';
      fullPath: '/account/$';
      preLoaderRoute: typeof AccountSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces': {
      id: '/_authenticated/workspaces';
      path: '/workspaces';
      fullPath: '/workspaces';
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$': {
      id: '/_authenticated/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof AuthenticatedSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/2fa_setup/$': {
      id: '/2fa_setup/$';
      path: '/2fa_setup/$';
      fullPath: '/2fa_setup/$';
      preLoaderRoute: typeof R2fa_setupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-studio-embed/cio/': {
      id: '/design-studio-embed/cio/';
      path: '/cio';
      fullPath: '/design-studio-embed/cio/';
      preLoaderRoute: typeof DesignStudioEmbedCioIndexRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/_authenticated/workspaces/': {
      id: '/_authenticated/workspaces/';
      path: '/';
      fullPath: '/workspaces/';
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/': {
      id: '/_authenticated/sample-workspace/';
      path: '/sample-workspace';
      fullPath: '/sample-workspace/';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/': {
      id: '/_authenticated/internal-tools/';
      path: '/internal-tools';
      fullPath: '/internal-tools/';
      preLoaderRoute: typeof AuthenticatedInternalToolsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/design-studio-embed/cio/$': {
      id: '/design-studio-embed/cio/$';
      path: '/cio/$';
      fullPath: '/design-studio-embed/cio/$';
      preLoaderRoute: typeof DesignStudioEmbedCioSplatRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/account/cancelled/$': {
      id: '/account/cancelled/$';
      path: '/account/cancelled/$';
      fullPath: '/account/cancelled/$';
      preLoaderRoute: typeof AccountCancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId': {
      id: '/_authenticated/workspaces/$workspaceId';
      path: '/$workspaceId';
      fullPath: '/workspaces/$workspaceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/_authenticated/trial-expired/journeys': {
      id: '/_authenticated/trial-expired/journeys';
      path: '/trial-expired/journeys';
      fullPath: '/trial-expired/journeys';
      preLoaderRoute: typeof AuthenticatedTrialExpiredJourneysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/privacy': {
      id: '/_authenticated/settings/privacy';
      path: '/settings/privacy';
      fullPath: '/settings/privacy';
      preLoaderRoute: typeof AuthenticatedSettingsPrivacyRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/experimental-features': {
      id: '/_authenticated/settings/experimental-features';
      path: '/settings/experimental-features';
      fullPath: '/settings/experimental-features';
      preLoaderRoute: typeof AuthenticatedSettingsExperimentalFeaturesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/ai': {
      id: '/_authenticated/settings/ai';
      path: '/settings/ai';
      fullPath: '/settings/ai';
      preLoaderRoute: typeof AuthenticatedSettingsAiRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/$': {
      id: '/_authenticated/settings/$';
      path: '/settings/$';
      fullPath: '/settings/$';
      preLoaderRoute: typeof AuthenticatedSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/$': {
      id: '/_authenticated/sample-workspace/$';
      path: '/sample-workspace/$';
      fullPath: '/sample-workspace/$';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/$': {
      id: '/_authenticated/internal-tools/$';
      path: '/internal-tools/$';
      fullPath: '/internal-tools/$';
      preLoaderRoute: typeof AuthenticatedInternalToolsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/pipelines/workspaces/$workspaceId/': {
      id: '/pipelines/workspaces/$workspaceId/';
      path: '/pipelines/workspaces/$workspaceId';
      fullPath: '/pipelines/workspaces/$workspaceId/';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId/': {
      id: '/_authenticated/workspaces/$workspaceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/settings/roles/': {
      id: '/_authenticated/settings/roles/';
      path: '/settings/roles';
      fullPath: '/settings/roles/';
      preLoaderRoute: typeof AuthenticatedSettingsRolesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/account/': {
      id: '/_authenticated/settings/account/';
      path: '/settings/account';
      fullPath: '/settings/account/';
      preLoaderRoute: typeof AuthenticatedSettingsAccountIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/pipelines/workspaces/$workspaceId/$': {
      id: '/pipelines/workspaces/$workspaceId/$';
      path: '/pipelines/workspaces/$workspaceId/$';
      fullPath: '/pipelines/workspaces/$workspaceId/$';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/tasks';
      path: '/tasks';
      fullPath: '/workspaces/$workspaceId/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/snippets';
      path: '/snippets';
      fullPath: '/workspaces/$workspaceId/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys_': {
      id: '/_authenticated/workspaces/$workspaceId/journeys_';
      path: '/journeys';
      fullPath: '/workspaces/$workspaceId/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home': {
      id: '/_authenticated/workspaces/$workspaceId/home';
      path: '/home';
      fullPath: '/workspaces/$workspaceId/home';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/health': {
      id: '/_authenticated/workspaces/$workspaceId/health';
      path: '/health';
      fullPath: '/workspaces/$workspaceId/health';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/geofences';
      path: '/geofences';
      fullPath: '/workspaces/$workspaceId/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio';
      path: '/design-studio';
      fullPath: '/workspaces/$workspaceId/design-studio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/assets': {
      id: '/_authenticated/workspaces/$workspaceId/assets';
      path: '/assets';
      fullPath: '/workspaces/$workspaceId/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent': {
      id: '/_authenticated/workspaces/$workspaceId/agent';
      path: '/agent';
      fullPath: '/workspaces/$workspaceId/agent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/$': {
      id: '/_authenticated/workspaces/$workspaceId/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/settings/roles/new': {
      id: '/_authenticated/settings/roles/new';
      path: '/settings/roles/new';
      fullPath: '/settings/roles/new';
      preLoaderRoute: typeof AuthenticatedSettingsRolesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/$roleId': {
      id: '/_authenticated/settings/roles/$roleId';
      path: '/settings/roles/$roleId';
      fullPath: '/settings/roles/$roleId';
      preLoaderRoute: typeof AuthenticatedSettingsRolesRoleIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/account/edit': {
      id: '/_authenticated/settings/account/edit';
      path: '/settings/account/edit';
      fullPath: '/settings/account/edit';
      preLoaderRoute: typeof AuthenticatedSettingsAccountEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/';
      path: '/pipelines';
      fullPath: '/workspaces/$workspaceId/pipelines/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/';
      path: '/parcel';
      fullPath: '/workspaces/$workspaceId/parcel/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/': {
      id: '/_authenticated/workspaces/$workspaceId/home/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/design-studio/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/suppressions': {
      id: '/_authenticated/workspaces/$workspaceId/settings/suppressions';
      path: '/settings/suppressions';
      fullPath: '/workspaces/$workspaceId/settings/suppressions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/merge_options': {
      id: '/_authenticated/workspaces/$workspaceId/settings/merge_options';
      path: '/settings/merge_options';
      fullPath: '/workspaces/$workspaceId/settings/merge_options';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/auto_archive': {
      id: '/_authenticated/workspaces/$workspaceId/settings/auto_archive';
      path: '/settings/auto_archive';
      fullPath: '/workspaces/$workspaceId/settings/auto_archive';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/audit-logs': {
      id: '/_authenticated/workspaces/$workspaceId/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/workspaces/$workspaceId/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api-keys': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/workspaces/$workspaceId/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': {
      id: '/_authenticated/workspaces/$workspaceId/settings/anonymous_events';
      path: '/settings/anonymous_events';
      fullPath: '/workspaces/$workspaceId/settings/anonymous_events';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': {
      id: '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile';
      path: '/settings/ai-business-profile';
      fullPath: '/workspaces/$workspaceId/settings/ai-business-profile';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/settings/$';
      path: '/settings/$';
      fullPath: '/workspaces/$workspaceId/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/$': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/$';
      path: '/parcel/$';
      fullPath: '/workspaces/$workspaceId/parcel/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/tasks';
      path: '/journeys/tasks';
      fullPath: '/workspaces/$workspaceId/journeys/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets';
      path: '/journeys/snippets';
      fullPath: '/workspaces/$workspaceId/journeys/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings';
      path: '/journeys/settings';
      fullPath: '/workspaces/$workspaceId/journeys/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences';
      path: '/journeys/geofences';
      fullPath: '/workspaces/$workspaceId/journeys/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/exports': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/exports';
      path: '/journeys/exports';
      fullPath: '/workspaces/$workspaceId/journeys/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/assets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/assets';
      path: '/journeys/assets';
      fullPath: '/workspaces/$workspaceId/journeys/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/$';
      path: '/journeys/$';
      fullPath: '/workspaces/$workspaceId/journeys/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup';
      path: '/workspace-setup';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': {
      id: '/_authenticated/workspaces/$workspaceId/dev/condition-viewer';
      path: '/dev/condition-viewer';
      fullPath: '/workspaces/$workspaceId/dev/condition-viewer';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/$': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/design-studio/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/deliverability';
      path: '/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills';
      path: '/skills';
      fullPath: '/workspaces/$workspaceId/agent/skills';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/routines': {
      id: '/_authenticated/workspaces/$workspaceId/agent/routines';
      path: '/routines';
      fullPath: '/workspaces/$workspaceId/agent/routines';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/';
      path: '/pipelines/sources';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/';
      path: '/pipelines/destinations';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/skills/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sinch': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sinch';
      path: '/settings/actions/sinch';
      fullPath: '/workspaces/$workspaceId/settings/actions/sinch';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys';
      path: '/pipelines/sources/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add';
      path: '/pipelines/sources/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId';
      path: '/pipelines/sources/$sourceId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys';
      path: '/pipelines/destinations/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add';
      path: '/pipelines/destinations/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      path: '/pipelines/destinations/$destinationId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/journeys/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability';
      path: '/journeys/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/journeys/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns';
      path: '/dev/db/campaigns';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/new': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/agent/skills/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath';
      path: '/$skillPath';
      fullPath: '/workspaces/$workspaceId/agent/skills/$skillPath';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId';
      path: '/pipelines/sources/add/$sourceOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      path: '/syncs';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      path: '/imports';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      path: '/databases';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      path: '/data-in';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId';
      path: '/pipelines/destinations/add/$destinationOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      path: '/tester';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      path: '/subscriptions';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      path: '/data-out';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add';
      path: '/pipelines/sources/$sourceId/syncs/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId';
      path: '/pipelines/sources/$sourceId/syncs/$syncId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      path: '/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      path: '/$subscriptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      path: '/actions/$actionId';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
  }
}

interface AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren: AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren: AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHealthRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
}

const AuthenticatedWorkspacesWorkspaceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHealthRoute:
      AuthenticatedWorkspacesWorkspaceIdHealthRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute:
      AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSinchRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdRouteChildren,
  );

interface AuthenticatedWorkspacesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute;
}

const AuthenticatedWorkspacesRouteChildren: AuthenticatedWorkspacesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdRouteWithChildren,
    AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  };

const AuthenticatedWorkspacesRouteWithChildren =
  AuthenticatedWorkspacesRoute._addFileChildren(
    AuthenticatedWorkspacesRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute;
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRouteWithChildren;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedInternalToolsSplatRoute: typeof AuthenticatedInternalToolsSplatRoute;
  AuthenticatedSampleWorkspaceSplatRoute: typeof AuthenticatedSampleWorkspaceSplatRoute;
  AuthenticatedSettingsSplatRoute: typeof AuthenticatedSettingsSplatRoute;
  AuthenticatedSettingsAiRoute: typeof AuthenticatedSettingsAiRoute;
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute;
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute;
  AuthenticatedSettingsExperimentalFeaturesRoute: typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  AuthenticatedSettingsPrivacyRoute: typeof AuthenticatedSettingsPrivacyRoute;
  AuthenticatedTrialExpiredJourneysRoute: typeof AuthenticatedTrialExpiredJourneysRoute;
  AuthenticatedInternalToolsIndexRoute: typeof AuthenticatedInternalToolsIndexRoute;
  AuthenticatedSampleWorkspaceIndexRoute: typeof AuthenticatedSampleWorkspaceIndexRoute;
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute;
  AuthenticatedSettingsAccountEditRoute: typeof AuthenticatedSettingsAccountEditRoute;
  AuthenticatedSettingsRolesRoleIdRoute: typeof AuthenticatedSettingsRolesRoleIdRoute;
  AuthenticatedSettingsRolesNewRoute: typeof AuthenticatedSettingsRolesNewRoute;
  AuthenticatedSettingsAccountIndexRoute: typeof AuthenticatedSettingsAccountIndexRoute;
  AuthenticatedSettingsRolesIndexRoute: typeof AuthenticatedSettingsRolesIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedInternalToolsSplatRoute: AuthenticatedInternalToolsSplatRoute,
  AuthenticatedSampleWorkspaceSplatRoute:
    AuthenticatedSampleWorkspaceSplatRoute,
  AuthenticatedSettingsSplatRoute: AuthenticatedSettingsSplatRoute,
  AuthenticatedSettingsAiRoute: AuthenticatedSettingsAiRoute,
  AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
  AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
  AuthenticatedSettingsExperimentalFeaturesRoute:
    AuthenticatedSettingsExperimentalFeaturesRoute,
  AuthenticatedSettingsPrivacyRoute: AuthenticatedSettingsPrivacyRoute,
  AuthenticatedTrialExpiredJourneysRoute:
    AuthenticatedTrialExpiredJourneysRoute,
  AuthenticatedInternalToolsIndexRoute: AuthenticatedInternalToolsIndexRoute,
  AuthenticatedSampleWorkspaceIndexRoute:
    AuthenticatedSampleWorkspaceIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsAccountEditRoute: AuthenticatedSettingsAccountEditRoute,
  AuthenticatedSettingsRolesRoleIdRoute: AuthenticatedSettingsRolesRoleIdRoute,
  AuthenticatedSettingsRolesNewRoute: AuthenticatedSettingsRolesNewRoute,
  AuthenticatedSettingsAccountIndexRoute:
    AuthenticatedSettingsAccountIndexRoute,
  AuthenticatedSettingsRolesIndexRoute: AuthenticatedSettingsRolesIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface CliRouteChildren {
  CliDnsSetupRoute: typeof CliDnsSetupRoute;
  CliIndexRoute: typeof CliIndexRoute;
}

const CliRouteChildren: CliRouteChildren = {
  CliDnsSetupRoute: CliDnsSetupRoute,
  CliIndexRoute: CliIndexRoute,
};

const CliRouteWithChildren = CliRoute._addFileChildren(CliRouteChildren);

interface DesignStudioEmbedRouteChildren {
  DesignStudioEmbedCioSplatRoute: typeof DesignStudioEmbedCioSplatRoute;
  DesignStudioEmbedCioIndexRoute: typeof DesignStudioEmbedCioIndexRoute;
}

const DesignStudioEmbedRouteChildren: DesignStudioEmbedRouteChildren = {
  DesignStudioEmbedCioSplatRoute: DesignStudioEmbedCioSplatRoute,
  DesignStudioEmbedCioIndexRoute: DesignStudioEmbedCioIndexRoute,
};

const DesignStudioEmbedRouteWithChildren =
  DesignStudioEmbedRoute._addFileChildren(DesignStudioEmbedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcademyLoginRoute: AcademyLoginRoute,
  CheckoutRoute: CheckoutRoute,
  CliRoute: CliRouteWithChildren,
  DesignStudioEmbedRoute: DesignStudioEmbedRouteWithChildren,
  R2fa_setupSplatRoute: R2fa_setupSplatRoute,
  AccountSplatRoute: AccountSplatRoute,
  Account_canceledSplatRoute: Account_canceledSplatRoute,
  Account_cancelledSplatRoute: Account_cancelledSplatRoute,
  Confirm_accountSplatRoute: Confirm_accountSplatRoute,
  Confirm_account_noticeSplatRoute: Confirm_account_noticeSplatRoute,
  EnvSplatRoute: EnvSplatRoute,
  HarSanitizerSplatRoute: HarSanitizerSplatRoute,
  IntegrationsSplatRoute: IntegrationsSplatRoute,
  JourneysSplatRoute: JourneysSplatRoute,
  LoginSplatRoute: LoginSplatRoute,
  LogoutSplatRoute: LogoutSplatRoute,
  No_accessible_workspacesSplatRoute: No_accessible_workspacesSplatRoute,
  OauthSplatRoute: OauthSplatRoute,
  Oauth2SplatRoute: Oauth2SplatRoute,
  Post_cancelSplatRoute: Post_cancelSplatRoute,
  Post_registrationSplatRoute: Post_registrationSplatRoute,
  Reset_passwordSplatRoute: Reset_passwordSplatRoute,
  SignupSplatRoute: SignupSplatRoute,
  UsersSplatRoute: UsersSplatRoute,
  VwbDemoSplatRoute: VwbDemoSplatRoute,
  AccountCancelledSplatRoute: AccountCancelledSplatRoute,
  PipelinesWorkspacesWorkspaceIdSplatRoute:
    PipelinesWorkspacesWorkspaceIdSplatRoute,
  PipelinesWorkspacesWorkspaceIdIndexRoute:
    PipelinesWorkspacesWorkspaceIdIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
